var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { MoreToolsBtn } from '../../desktopApp/longread/editor/EditorToolbar/styles';
import styled from 'styled-components';
import { FlexBox, HintTooltip } from '@brg/ui';
import useLocalization from '../../../hooks/useLocalization';
var ToolBox = styled(FlexBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    flex-flow: row;\n"], ["\n    flex-flow: row;\n"])));
export var MoreTools = function (_a) {
    var visibility = _a.visibility, onToggleVisible = _a.onToggleVisible, children = _a.children;
    var t = useLocalization().t;
    return (React.createElement(ToolBox, { gx: 16, gxMobile: 16 },
        !visibility && (React.createElement(HintTooltip, { z: 9, h: '32px', text: t('hint.more'), positionY: "bottom", noArrow: true, noDisappearDelay: true },
            React.createElement(MoreToolsBtn, { onClick: onToggleVisible }))),
        visibility && children));
};
var templateObject_1;
//# sourceMappingURL=MoreTools.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { MoreToolsBtn } from '../../desktopApp/longread/editor/EditorToolbar/styles';
import styled from 'styled-components';
import { FlexBox, HintTooltip } from '@brg/ui';
import useLocalization from '../../../hooks/useLocalization';
var ToolBox = styled(FlexBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    flex-flow: row;\n"], ["\n    flex-flow: row;\n"])));
export var MoreTools = function (_a) {
    var visibility = _a.visibility, onToggleVisible = _a.onToggleVisible, children = _a.children;
    var t = useLocalization().t;
    return (React.createElement(ToolBox, { gx: 16, gxMobile: 16 },
        !visibility && (React.createElement(HintTooltip, { z: 9, h: '32px', text: t('hint.more'), positionY: "bottom", noArrow: true, noDisappearDelay: true },
            React.createElement(MoreToolsBtn, { onClick: onToggleVisible }))),
        visibility && children));
};
var templateObject_1;
//# sourceMappingURL=MoreTools.js.map